import React, { useState, useEffect, useCallback } from 'react'
import { Bell } from 'lucide-react'
import './NotificationV2.css'
import { useNavigate } from 'react-router-dom'
import { getNotificationCount } from '../../services/auth/Notification/NotificationApi'

const NotificationV2 = () => {
  const [unreadCount, setUnreadCount] = useState(0)
  const navigate = useNavigate()

  const fetchCount = useCallback(async () => {
    try {
      const res = await getNotificationCount()
      setUnreadCount(res?.data?.unread || 0)
    } catch (err) {
      console.error('Error fetching notification count:', err)
    }
  }, [])

   useEffect(() => {
     fetchCount()
     const interval = setInterval(fetchCount, 30000)

     // Refetch immediately whenever a notification is opened/completed/cleared
     // elsewhere in the app, instead of waiting for the next 60s poll.
     window.addEventListener('notifications:updated', fetchCount)

     return () => {
       clearInterval(interval)
       window.removeEventListener('notifications:updated', fetchCount)
     }
   }, [fetchCount])

  const handleRedirect = () => {
    navigate('/notifications')
  }

  return (
    <div className="notification-container">
      <div className="notification-bell" onClick={handleRedirect}>
        <Bell size={20} />
        {unreadCount > 0 && <span className="notification-badge">{unreadCount}</span>}
      </div>
    </div>
  )
}

export default NotificationV2
